import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./Components/Header/HomePage";
import Sound from "./Components/Sound/Sound";
import Band from "./Components/Band/Band";
import Menu from "./Components/Header/Menu";
import Press from "./Components/Press/Press";
import Contacts from "./Components/Сontacts/Сontacts";
import NotFound from "./Components/Page/NotFound";

function App() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollToTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Router>
      <header className={`header ${isPlaying ? "pulsing" : ""}`}>
        <div className="logo">MINTSKOPLENOK</div>
        <Menu />
      </header>

      {showScrollToTop && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          ↑
        </button>
      )}

      <Routes>
        <Route
          path="/"
          element={
            <>
              <div className="hero">
                <div className="hero-content">
                  <HomePage />
                </div>
              </div>

              <section className="section">
                <h2 id="more-music">Последние альбомы</h2>
                <p>Ознакомьтесь с последними музыкальными релизами и альбомами группы.</p>
                <Sound setIsPlaying={setIsPlaying} />
              </section>

              <section className="section">
                <h2 id="more-band">О группе</h2>
                <p>Узнайте больше об истории, участниках группы MINTSKOPLENOK.</p>
                <Band />
              </section>

              <section className="section">
                <h2 id="press">MINTSKOPLENOK в прессе</h2>
                <p>Интервью группы в изданиях и не только</p>
                <Press />
              </section>

              <section className="section">
                <h2 id="contact">Свяжитесь с нами</h2>
                <p>По вопросам рекламы, концертов или сотрудничества напишите нам:</p>
                <Contacts />
              </section>
            </>
          }
        />
        <Route path="/press" element={<Press />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <footer>
        &copy; 2024 - {new Date().getFullYear()} MINTSKOPLENOK Fan Website | All Rights Reserved
      </footer>
    </Router>
  );
}

export default App;
